__turbopack_context__.v({
  "actions": "Header-module__hBw1pG__actions",
  "authLink": "Header-module__hBw1pG__authLink",
  "burger": "Header-module__hBw1pG__burger",
  "header": "Header-module__hBw1pG__header",
  "headerInner": "Header-module__hBw1pG__headerInner",
  "langSelect": "Header-module__hBw1pG__langSelect",
  "logo": "Header-module__hBw1pG__logo",
  "logoText": "Header-module__hBw1pG__logoText",
  "mobileOpen": "Header-module__hBw1pG__mobileOpen",
  "nav": "Header-module__hBw1pG__nav",
});
